import { theme } from '@riac/design-system';
import styled from 'styled-components';

export const NRAFFFOSDOverlay = styled.img`
  position: absolute;
  bottom: 15px;
  left: 10px;
  width: 10%;
  min-width: 70px;
  max-width: 80px;
  z-index: 1;

  user-select: none;
  pointer-events: none;

  ${theme.tablet} {
    min-width: 90px;
    max-width: 100px;
  }

  ${theme.desktop} {
    min-width: 120px;
    max-width: 130px;
  }
`;
